<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Zendesk" class="d-icon d-icon--zendesk" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M11.238 19.156V8.002L2 19.156h9.238ZM9.885 7.266A4.62 4.62 0 0 0 11.238 4H2a4.62 4.62 0 0 0 7.885 3.266Zm4.228 8.624a4.619 4.619 0 0 0-1.353 3.267h9.238a4.619 4.619 0 0 0-7.885-3.267ZM12.76 4v11.153L22 4h-9.24Z" fill="#00A656"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconZendesk',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
